import type { QueryClient, QueryKey } from '@tanstack/react-query';

/** These roots contain caller-owned data, unlike admin queues or catalogue data. */
export function isSessionPrivateQueryKey(key: QueryKey): boolean {
  return (
    key[0] === 'customer' ||
    key[0] === 'applications' ||
    key[0] === 'contracts' ||
    (key[0] === 'auth' && key[1] === 'sessions')
  );
}

/** Keep legacy prefixes so existing mutation invalidation still matches. */
export function sessionQueryKey(key: QueryKey, userId: string | null): QueryKey {
  return isSessionPrivateQueryKey(key) ? [...key, { authenticatedUserId: userId }] : key;
}

export function removeSessionPrivateQueries(client: QueryClient): void {
  const filter = {
    predicate: (query: { queryKey: QueryKey }) => isSessionPrivateQueryKey(query.queryKey),
  };
  // Cancellation is synchronous; late responses cannot repopulate removed queries.
  void client.cancelQueries(filter, { silent: true, revert: false });
  client.removeQueries(filter);
}
